exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-f7678bb8]{margin:.75rem}form>div.img-container[data-v-f7678bb8]{margin:.75rem;display:flex;justify-content:center;align-items:center}form>div.img-container>img[data-v-f7678bb8]{width:100px}form>button[data-v-f7678bb8]{margin-top:.75rem}", ""]);

// exports
